.disclaimer {
	width: 100%;
	height: fit-content;
	padding: 14px;
	display: flex;
	gap: 8px;
	border-radius: 8px;
}

.content {
	display: flex;
	flex-direction: column;
	gap: 2px;
	flex: 1;
	min-width: 0;
}

.action {
	flex-shrink: 0;
	align-self: center;
}

.warning {
	border: solid var(--border-warning) 1px;
	color: var(--content-warning);
	background-color: var(--background-warning);

	h3,
	p {
		color: var(--content-warning);
	}
}

.danger {
	border: solid var(--border-error) 1px;
	color: var(--content-error);

	h3,
	p {
		color: var(--content-error);
	}
}

.info {
	border: solid var(--border-primary) 1px;
	color: var(--content-primary);

	h3 {
		color: var(--content-primary);
	}

	p {
		color: var(--content-tertiary);
	}
}

.note {
	padding: 8px 12px;
	background-color: var(--background-info-low);

	h3,
	p {
		color: var(--content-tertiary);
	}
}

/* Forces the icon size regardless the disclaimer content */
.iconWrapper {
	width: 16px;
	height: 16px;
	margin-top: 3px;
}

.note .iconWrapper {
	width: 14px;
	height: 14px;
	margin-top: 0.75px;
	color: var(--content-tertiary);
}
